import React from "react";

const Star = () => (
  <svg
    className="star-svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#fff"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polygon points="12 2 15 8.5 22 9.3 17 14 18.5 21 12 17.5 5.5 21 7 14 2 9.3 9 8.5 12 2" />
  </svg>
);

const StarButton = ({ text = "Read More", link = "#" }) => {
  return (
    <a href={link} target="_blank" className="star-button">
      {text}
      <div className="star star-1"><Star /></div>
      <div className="star star-2"><Star /></div>
      <div className="star star-3"><Star /></div>
      <div className="star star-4"><Star /></div>
      <div className="star star-5"><Star /></div>
      <div className="star star-6"><Star /></div>
    </a>
  );
};

export default StarButton;
